export const AbbreviateNameFilter = {

	/*
	**  Set up the filters
	*/

	filters: {

		abbreviateName: function(value) {

			return value.charAt(0);

		}

	}
	
}